import EditButton from "@/app/(site)/[locale]/checkout/CheckoutContent/components/StepDetails/EditButton"
import { usePaymentResultEvent } from "@/app/(site)/_utils/_hooks/usePaymentResultEvent"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { type CheckoutStep } from "@/app/(site)/contexts/ecommerce/types"
import { clsx } from "@/src/utils/clsx"

export default function StepHeading({
    title,
    className,
    titleClassName,
    toStep,
    langCode,
    showEditButton = true,
    onEditClick
}: {
    title: string
    className?: string
    titleClassName?: string
    toStep?: CheckoutStep
    langCode: string
    showEditButton?: boolean
    onEditClick?: () => void
}) {
    const { checkoutCurrentStep, setCheckoutCurrentStep } = useEcommerceStore()
    const isRoutingToPaymentResult = usePaymentResultEvent()
    return (
        <div className={clsx("flex justify-between", className)}>
            <h3
                className={clsx(
                    "Trim_Mono_POC_Text_18_130_-3_500_uppercase",
                    titleClassName
                )}
            >
                {title}
            </h3>
            {showEditButton && !isRoutingToPaymentResult && (
                <EditButton
                    langCode={langCode}
                    toStep={toStep}
                    checkoutCurrentStep={checkoutCurrentStep}
                    setCheckoutCurrentStep={setCheckoutCurrentStep}
                    onEditClick={onEditClick}
                />
            )}
        </div>
    )
}
